import axios from 'axios';

export type UpdateDealDesignImagesParams = {
	dealId: string;
	email: string;
	designLabel: string;
	overheadImage: string;
	threeDImage: string;
	getToken: () => Promise<string>;
};

export const updateDealDesignImages = async (params: UpdateDealDesignImagesParams): Promise<[boolean, string | null]> => {
	const { dealId, email, designLabel, overheadImage, threeDImage, getToken } = params;

	try {
		const token = await getToken();
		const apiUrl = import.meta.env.VITE_API_URL;
		const response = await axios.patch(`${apiUrl}/deals/${dealId}/design-images`, {
			email,
			designLabel,
			overheadImage,
			threeDImage
		}, {
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'application/json'
			}
		});

		if (response.status === 200) return [true, null];
		throw new Error('Error updating deal design images');
	} catch (error) {
		console.error('updateDealDesignImages:error', error);
		return [false, 'Error updating deal design images'];
	}
};
